"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _truck = require("@/api/truck.api");

var _elementUi = require("element-ui");

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TIME_STEPPER_KEY = 'timeStepper';

var MiniGanttChartV2Component = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MiniGanttChartV2Component, _Mixins);

  var _super = _createSuper(MiniGanttChartV2Component);

  function MiniGanttChartV2Component() {
    var _this;

    (0, _classCallCheck2.default)(this, MiniGanttChartV2Component);
    _this = _super.apply(this, arguments);
    _this.truckWidth = 0;
    _this.routes = [];
    _this.trucks = [];
    _this.truckData = {};
    _this.selectedTrucks = [];
    _this.ganttChartLoading = true;
    _this.isTicking = false;
    _this.lastScrollLeft = 0;
    _this.timeList = [];
    _this.numOfDaysAdded = 1;
    _this.autoAddedDays = 1;
    _this.maxAutoAddedDays = 1;
    _this.timeSteppers = [15, 30, 60];
    _this.timeStepper = 30;
    _this.earliestDate = null;
    _this.currentTimeInterval = null;
    _this.currentTimeRefresh = 60; // seconds

    _this.currentTimeLeft = null;
    _this.leftWidth = 225;
    _this.smallLeftWidth = 100;
    _this.currentPlanOrdersLen = 0;
    _this.isRealProcessingTime = false;
    _this.defaultProcessingTime = 15;
    return _this;
  }

  (0, _createClass2.default)(MiniGanttChartV2Component, [{
    key: "onDDChanges",
    value: function onDDChanges(newVal) {
      this.earliestDate = newVal;
    }
  }, {
    key: "onValueChanges",
    value: function onValueChanges(newVal, oldVal) {
      this.updateData(newVal, this.allCompany);
    }
  }, {
    key: "onPlanDateChanges",
    value: function onPlanDateChanges(newVal) {
      this.timeList = this.getTimeList(this.numOfDaysAdded, newVal);
      this.selectedTrucks = [];

      if ((0, _moment.default)(newVal).isBefore(this.earliestDate)) {
        this.earliestDate = this.$planDate;
      }
    }
  }, {
    key: "onTimeStepperChanges",
    value: function onTimeStepperChanges(newVal) {
      var _this2 = this;

      window.localStorage.setItem(TIME_STEPPER_KEY, newVal);
      this.timeList = this.getTimeList(this.numOfDaysAdded);
      this.$nextTick(function () {
        _this2.handleHorizontallyScrolling();

        _this2.getCurrentTimeLocation();
      });
    }
  }, {
    key: "onGanttChartLoadingChanges",
    value: function onGanttChartLoadingChanges() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.handleHorizontallyScrolling();

        _this3.getCurrentTimeLocation();

        if (!_this3.helper.isUndefined(document.getElementById('ganttChart'))) {
          document.getElementById('ganttChart').addEventListener('scroll', _this3.handleGCEndScroll);
        }
      });
    }
  }, {
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "$isMobile",
    get: function get() {
      return this.$store.getters['common/isMobile'];
    },
    set: function set(newVal) {
      this.$setIsMobile(newVal);
    }
  }, {
    key: "$planDate",
    get: function get() {
      return this.$store.getters['lastMileDelivery/planDate'];
    }
  }, {
    key: "gcContainerStyle",
    get: function get() {
      return {
        height: this.ganttChartHeight + 'px',
        top: 0
      };
    }
  }, {
    key: "gcHeaderStyle",
    get: function get() {
      return {
        width: this.truckWidth + 'px'
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.currentTimeInterval) {
        clearInterval(this.currentTimeInterval);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.ganttChartLoading = true;
      this.timeList = this.getTimeList(this.defaultDaysOfIncrement, this.defaultDate);
      this.earliestDate = this.$planDate;

      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }

      if (!this.truckAPI) {
        this.truckAPI = new _truck.TruckAPI({
          lfToken: this.$lfToken || null,
          userSetting: this.$userSetting
        });
      }

      this.updateData(this.routing, this.allCompany);
      this.isRealProcessingTime = this.$userSetting['default27'] || false;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this4 = this;

      var timeStepper = window.localStorage.getItem(TIME_STEPPER_KEY);

      if (!this.helper.isUndefined(timeStepper)) {
        this.timeStepper = Number(timeStepper);
      }

      this.currentTimeInterval = setInterval(function () {
        _this4.getCurrentTimeLocation();

        _this4.handleHorizontallyScrolling();
      }, this.currentTimeRefresh * 1000);
    }
  }, {
    key: "updateData",
    value: function updateData() {
      var _this5 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var allCompany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.ganttChartLoading = true;
      this.currentPlanOrdersLen = this.helper.get(data, 'orderId', []).length;
      this.routes = data && data['data'] ? data['data'] : [];
      this.trucks = data && data['truckId'] ? data['truckId'] : [];
      var query = "id:".concat(this.trucks.join(','));
      return this.truckAPI.getTrucksV2(query, false, allCompany).then(function (truckData) {
        if (truckData.failed) {
          return Promise.reject(truckData.message || '');
        }

        _this5.ganttChartLoading = false;

        if (truckData.data && truckData.data.length >= 1) {
          truckData.data.forEach(function (tData) {
            if (tData['id'] && _this5.helper.isInArray(tData['id'], _this5.trucks)) {
              _this5.truckData[tData['id']] = tData;
            }
          });
          _this5.numOfDaysAdded = 1;
          _this5.maxAutoAddedDays = 0;

          if (_this5.defaultDaysOfIncrement > 1) {
            _this5.numOfDaysAdded = _this5.defaultDaysOfIncrement;
          }

          _this5.timeList = _this5.defaultDate ? _this5.getTimeList(_this5.numOfDaysAdded, _this5.defaultDate) : _this5.getTimeList(_this5.numOfDaysAdded);
          _this5.ganttChartLoading = false;
        }
      }).catch(function (error) {
        _this5.ganttChartLoading = false;
        _this5.truckData = {};
      });
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(truckId) {
      return this.helper.get(this.helper.filter(this.routes, function (truck) {
        return truck['truckId'] === truckId;
      }), '0.routes', []);
    }
  }, {
    key: "handleHorizontallyScrolling",
    value: function handleHorizontallyScrolling() {
      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return false;
      }

      var start = (0, _moment.default)(new Date()).format('YYYY-MM-DD 00:00');
      var end = (0, _moment.default)(new Date());

      var duration = _moment.default.duration(end.diff(start, 'minutes'), 'minutes').asMinutes();

      var xAxis = duration * this.ganttChartCellWidth / this.timeStepper;
      var xPos = xAxis - el.clientWidth / 3;
      el.scrollBy(xPos, 0);
    }
  }, {
    key: "checkSelected",
    value: function checkSelected(truckId) {
      return truckId && this.helper.isInArray(truckId, this.selectedTrucks);
    }
  }, {
    key: "unselectTruck",
    value: function unselectTruck(truckId) {
      var selectedTrucks = this.selectedTrucks.indexOf(truckId);

      if (selectedTrucks > -1) {
        this.selectedTrucks.splice(selectedTrucks, 1);
      }

      this.$removeDashboardVehicles({
        'id': truckId
      });
      this.$emit('selectedFunction', this.selectedTrucks, this.index);
    }
  }, {
    key: "selectTruck",
    value: function selectTruck(truckId) {
      this.selectedTrucks.push(truckId);
      this.$appendDashboardVehicles({
        'id': truckId,
        'color': this.helper.randomColor
      });
      this.$emit('selectedFunction', this.selectedTrucks, this.index);
    }
  }, {
    key: "getSelectColor",
    value: function getSelectColor(truckId) {
      var color = this.$dashboardVehicles.find(function (vehicle) {
        return vehicle['id'] === truckId;
      });
      return color && color['color'] ? color['color'] : '#387fc2';
    }
  }, {
    key: "handleGCEndScroll",
    value: function handleGCEndScroll() {
      var _this6 = this;

      var ganttChart = this.helper.get(this.$refs, 'ganttChart', null);

      if (ganttChart && !this.isTicking) {
        // Throttle the firing of the event
        window.requestAnimationFrame(function () {
          var documentScrollLeft = ganttChart.scrollLeft;

          if (_this6.lastScrollLeft !== documentScrollLeft) {
            if (ganttChart.scrollWidth - documentScrollLeft === ganttChart.clientWidth && _this6.autoAddedDays < _this6.maxAutoAddedDays) {
              // this.logger.info('End of scroll');
              _this6.numOfDaysAdded++;
              _this6.autoAddedDays++;
              _this6.timeList = _this6.getTimeList(_this6.numOfDaysAdded);
            }

            _this6.lastScrollLeft = documentScrollLeft;
          }

          _this6.isTicking = false;
        });
        this.isTicking = true;
      }
    }
  }, {
    key: "getTimeList",
    value: function getTimeList() {
      var daysOfIncrement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.earliestDate;
      var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.earliestDate;
      var stepper = this.timeStepper;
      var start = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.earliestDate) : (0, _moment.default)(startDate);
      var eDate = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.earliestDate) : (0, _moment.default)(endDate);
      var end = daysOfIncrement === 0 ? (0, _moment.default)(eDate) : (0, _moment.default)(startDate).add(daysOfIncrement, 'days');

      var duration = _moment.default.duration(end.diff(start, 'days'), 'days').asDays();

      var endTime = (0, _moment.default)('00:00', 'HH:mm').subtract(stepper, 'm').format('HH:mm');
      var arr = [];
      var ctr = 0;

      for (var i = 0; i <= duration; i++) {
        var time = (0, _moment.default)('00:00', 'HH:mm');
        ctr = ctr + (i === 0 ? 0 : 1);
        var obj = {
          date: i === 0 ? start.format('YYYY-MM-DD') : start.add(1, 'days').format('YYYY-MM-DD'),
          timeList: [{
            time: time.format('HH:mm'),
            counter: ctr
          }]
        };

        while (time.format('HH:mm') !== endTime) {
          ctr++;
          time = time.add(stepper, 'm');
          obj['timeList'].push({
            time: time.format('HH:mm'),
            counter: ctr
          });
        }

        arr.push(obj);
      }

      var numOfDays = arr.length;

      if (arr[0] && arr[0]['timeList']) {
        this.truckWidth = numOfDays * arr[0]['timeList'].length * this.ganttChartCellWidth + (this.$isMobile ? this.smallLeftWidth : this.leftWidth);
      }

      return arr;
    }
  }, {
    key: "getStatusColor",
    value: function getStatusColor(route) {
      var cssClass = {
        'pick-up': route['waypointType'] === 'P',
        'unassigned': false,
        'assigned': false,
        'completed': false
      };
      var status = route['status'];

      if (route['status'] === 'COMPLETED') {
        if (!route['completepointId'] || route['completepointId'].length !== route['waypointId'].length) {
          status = 'PARTIAL-COMPLETED';
        }
      }

      cssClass[status] = true;
      return cssClass;
    }
  }, {
    key: "getContainerStyles",
    value: function getContainerStyles(route) {
      return {
        top: '6px',
        left: this.getContainerDimension(true, route) + 'px',
        width: this.getContainerDimension(false, route) + 'px',
        height: '20px'
      };
    }
  }, {
    key: "getContainerDimension",
    value: function getContainerDimension(isLeft) {
      var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isMockTime = !this.isRealProcessingTime && route['status'].toUpperCase() === 'COMPLETED';
      var newRoute = this.helper.cloneDeep(route);
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.processingTime = isMockTime ? this.defaultProcessingTime : Number(newRoute.processingTime) / 60;
      var sTime = isMockTime ? (0, _moment.default)(newRoute.endTime).subtract(this.defaultProcessingTime + newRoute.time, 'minutes').format('YYYY-MM-DD HH:mm:ss') : newRoute.startTime;
      var start = this.helper.convertTimezone(sTime, this.$timezone);
      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDate) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDate), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }

      return multiplier * (isLeft ? duration : newRoute.time + newRoute.processingTime);
    }
  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(route, dimensionType) {
      return {
        left: this.getLeftDimension(dimensionType, route) + 'px',
        width: this.getWidthDimension(dimensionType, route) + 'px',
        opacity: route['isHighlighted'] ? 0.5 : 1
      };
    }
    /**
     * 30 minutes   = 54      <-- ganttChartCellWidth
     * 1 minute     = 1.8px   <-- 54/this.stepper
     * */

  }, {
    key: "getLeftDimension",
    value: function getLeftDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.processingTime = Number(newRoute.processingTime) / 60;

      if (timeType === 'travellingTime') {
        return 0;
      }

      if (timeType === 'processingTime') {
        return multiplier * newRoute.time;
      }
    }
  }, {
    key: "getWidthDimension",
    value: function getWidthDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.processingTime = Number(newRoute.processingTime) / 60;

      if (timeType === 'travellingTime') {
        return multiplier * newRoute.time;
      }

      if (timeType === 'processingTime') {
        var processingTime = newRoute.processingTime === 0 ? 15 : newRoute.processingTime;

        if (!this.isRealProcessingTime && route['status'].toUpperCase() === 'COMPLETED') {
          processingTime = this.defaultProcessingTime;
        }

        return multiplier * processingTime;
      }
    }
  }, {
    key: "getCurrentTimeLocation",
    value: function getCurrentTimeLocation() {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var start = (0, _moment.default)(new Date());
      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDate) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDate), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }

      this.currentTimeLeft = multiplier * duration;
    }
  }, {
    key: "getGCRowClass",
    value: function getGCRowClass(truck, truckIndex) {
      return {
        'is-active': truck === this.highlightedTruckId,
        'bdr-btm-none': truckIndex === this.trucks.length - 1
      };
    }
  }, {
    key: "getGCRowStyle",
    value: function getGCRowStyle(truck, truckIndex) {
      return {
        'width': this.truckWidth + 'px',
        'margin-top': truckIndex === 0 ? '1px' : '0'
      };
    }
  }, {
    key: "getDuration",
    value: function getDuration(route, type) {
      switch (type) {
        case 'processingTime':
        default:
          return !this.isRealProcessingTime && route.status.toUpperCase() === 'COMPLETED' ? this.helper.printThousandDecimal(this.defaultProcessingTime) : this.helper.printThousandDecimal(route.processingTime / 60);
      }
    }
  }, {
    key: "getTime",
    value: function getTime(route, type) {
      switch (type) {
        case 'startTime':
          return !this.isRealProcessingTime && route.status.toUpperCase() === 'COMPLETED' ? (0, _moment.default)(route.endTime).subtract(this.defaultProcessingTime + route.time / 60, 'minutes').format('YYYY-MM-DD HH:mm:ss') : route.startTime;

        case 'estimateTime':
        default:
          return !this.isRealProcessingTime && route.status.toUpperCase() === 'COMPLETED' ? (0, _moment.default)(route.endTime).subtract(this.defaultProcessingTime, 'minutes').format('YYYY-MM-DD HH:mm:ss') : route.estimateTime;
      }
    }
  }, {
    key: "getTranslation",
    value: function getTranslation(route, type) {
      switch (type) {
        case 'estimateTime':
          return route.status.toUpperCase() === 'COMPLETED' ? this.$t('planning.tooltip.arrivalTime') : this.$t('planning.tooltip.eta');

        case 'endTime':
        default:
          return route.status.toUpperCase() === 'COMPLETED' ? this.$t('planning.tooltip.end') : this.$t('planning.tooltip.expectedEnd');
      }
    }
  }]);
  return MiniGanttChartV2Component;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], MiniGanttChartV2Component.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MiniGanttChartV2Component.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], MiniGanttChartV2Component.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('dashboardVehicles', {
  namespace: 'common'
})], MiniGanttChartV2Component.prototype, "$dashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('ADD_DASHBOARD_VEHICLES', {
  namespace: 'common'
})], MiniGanttChartV2Component.prototype, "$appendDashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('REMOVE_DASHBOARD_VEHICLES', {
  namespace: 'common'
})], MiniGanttChartV2Component.prototype, "$removeDashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_MOBILE', {
  namespace: 'common'
})], MiniGanttChartV2Component.prototype, "$setIsMobile", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: null
})], MiniGanttChartV2Component.prototype, "highlightedTruckId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 54
})], MiniGanttChartV2Component.prototype, "ganttChartCellWidth", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 600
})], MiniGanttChartV2Component.prototype, "ganttChartHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: {}
})], MiniGanttChartV2Component.prototype, "routing", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MiniGanttChartV2Component.prototype, "allCompany", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 0
})], MiniGanttChartV2Component.prototype, "index", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 0
})], MiniGanttChartV2Component.prototype, "defaultDaysOfIncrement", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], MiniGanttChartV2Component.prototype, "defaultDate", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('defaultDate')], MiniGanttChartV2Component.prototype, "onDDChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routing', {
  deep: true
})], MiniGanttChartV2Component.prototype, "onValueChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDate')], MiniGanttChartV2Component.prototype, "onPlanDateChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('timeStepper')], MiniGanttChartV2Component.prototype, "onTimeStepperChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('ganttChartLoading')], MiniGanttChartV2Component.prototype, "onGanttChartLoadingChanges", null);
MiniGanttChartV2Component = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MiniGanttChartV2Component',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip,
    'el-dialog': _elementUi.Dialog,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem
  },
  props: {
    value: {
      type: Object,
      default: function _default() {}
    },
    date: {
      type: String,
      default: ''
    },
    allCompany: {
      type: Boolean,
      default: false
    },
    selectedFunction: {
      type: Function,
      default: function _default() {}
    },
    selectedValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
})], MiniGanttChartV2Component);
var _default2 = MiniGanttChartV2Component;
exports.default = _default2;